<!-- components/Download.svelte -->
<script>
  import { t } from "../libs/i18n";

  let aboutSrc = "assets/img/about.jpg";
</script>


<!-- ======= Download Section ======= -->
<section id="download" class="services">
  <div class="container">

    <div class="section-title">
      <h3>{$t("download.title1")} <span>{$t("download.title2")} </span>{$t("download.title3")} </h3>
    </div>

    <div class="row">
      <div class="col-md-6 col-lg-6 d-flex align-items-stretch mb-5 mb-lg-0">
        <a href={'https://apps.apple.com/tw/app/learn-japanese-speak-aoi/id1639964534'} target="_blank" class="download-link">
          <img src="assets/img/download/apple_eng.svg" class="img-fluid download-icon" alt="">
        </a>
      </div>

      <div class="col-md-6 col-lg-6 d-flex align-items-stretch mb-5 mb-lg-0">
        <a href={'https://play.google.com/store/apps/details?id=com.db.lingotv'} target="_blank" class="download-link">
          <img src="assets/img/download/google_eng.svg" class="img-fluid download-icon" alt="">
        </a>
      </div>
    </div>

  </div>
</section><!-- End Download Section -->